import { render } from "./SubsectionLink.vue?vue&type=template&id=3127daf3&scoped=true"
import script from "./SubsectionLink.vue?vue&type=script&lang=js"
export * from "./SubsectionLink.vue?vue&type=script&lang=js"

import "./SubsectionLink.vue?vue&type=style&index=0&id=3127daf3&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3127daf3"]])

export default __exports__